export default __webpack_public_path__ + "static/media/RanilleNormalRegular-axEpm.e8bf1848.otf";